import { render, staticRenderFns } from "./basicSet.vue?vue&type=template&id=dfff0d8c&scoped=true&"
import script from "./basicSet.vue?vue&type=script&lang=js&"
export * from "./basicSet.vue?vue&type=script&lang=js&"
import style0 from "./basicSet.vue?vue&type=style&index=0&id=dfff0d8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfff0d8c",
  null
  
)

export default component.exports